












































import {
  HasTaskMixin, formatDateTime, ShowFinally, Message,
} from 'mycorems-app-shared';
import repository from './payment-repository';
import {
  Payment, QueryResult, QueryFilters, QPagination,
} from '../types';
import Money from '../price/Money.vue';
import DownloadReceiptBtn from './DownloadReceiptBtn.vue';

interface Data {
  columns: object[],
  pagination: QPagination,
  payments: Payment[],
}

export default HasTaskMixin.extend({
  props: {
    customerId: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      columns: [
        {
          name: 'description',
          label: 'Description',
          field: (payment: Payment) => payment.description,
          align: 'left',
        },
        {
          name: 'subTotal',
          label: 'Subtotal',
          field: 'subTotal',
          align: 'left',
        },
        {
          name: 'tax',
          label: 'Tax',
          field: (payment: Payment) => payment.total - payment.subTotal,
          align: 'left',
        },
        {
          name: 'total',
          label: 'Total',
          field: 'total',
          align: 'left',
        },
        {
          name: 'charged',
          label: 'Paid on',
          field: 'createdAt',
          align: 'left',
        },
        {
          name: 'actions',
          align: 'center',
        },
      ],
      pagination: {
        page: 1,
        rowsPerPage: 5,
        rowsNumber: 0,
      },
      payments: [],
    };
  },
  watch: {
    customerId: {
      handler() {
        this.load();
      },
      immediate: true,
    },
    filters: 'load',
  },
  computed: {
    offset(): number {
      return (this.pagination.page - 1) * this.pagination.rowsPerPage;
    },
    filters(): QueryFilters {
      return {
        offset: this.offset,
        limit: this.pagination.rowsPerPage,
      };
    },
  },
  methods: {
    load() {
      this.task = repository.findAll(this.customerId, this.filters);
      this.task.then((result: QueryResult) => {
        this.pagination.rowsNumber = result.total;
        this.payments = (result.items as Payment[]);
      });
    },
  },
  filters: {
    datetime(value: string): string {
      return formatDateTime(value);
    },
  },
  components: {
    Money,
    ShowFinally,
    Message,
    DownloadReceiptBtn,
  },
});
